import axiosInstance from "../../api/axiosInstance";

export const fetchUsersByQueryAPI = async (query, kind = "user") => {
  if (kind === "squad") {
    const squadsList = await axiosInstance.get(
      `squads/dashboard-search-for-squad?query=${query}&page=1&limit=20`,
    );

    return {
      query,
      kind,
      data: squadsList?.data?.data?.data || [],
    };
  }

  const usersList = await axiosInstance.get(
    `users/dashboard-search-for-user?query=${query}`,
  );

  return {
    query,
    kind: "user",
    data: usersList?.data?.data || [],
  };
};
